'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PricingLevelFeature = _react2['default'].createClass({
    displayName: 'PricingLevelFeature',

    render: function render() {
        var classes = (0, _classnames2['default'])({
            'm-pricing-level--feature': true,
            'small-12': true,
            'columns': true,
            'block': true,
            'expanded': this.props.expanded
        });

        if (this.props.planName && this.props.planName.toLowerCase().indexOf('pro') === 0) {
            var numberClasses = (0, _classnames2['default'])({
                'number': true,
                'c-cerulean': this.props.name.toLowerCase().indexOf('documents per month') === 0
            });
        } else {
            var numberClasses = (0, _classnames2['default'])({
                'number': true,
                'c-cerulean': !this.props.isFree
            });
        }

        var nameClasses = (0, _classnames2['default'])({
            'name': true
        });

        var number = _jsx('div', {
            className: numberClasses
        }, void 0, this.props.number);
        var name = _jsx('div', {
            className: nameClasses
        }, void 0, this.props.name);
        var detail = _jsx('div', {
            className: 'detail'
        }, void 0, this.props.detail);
        return _jsx('div', {
            className: classes
        }, void 0, number, name, detail);
    }
});

module.exports = PricingLevelFeature;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/pricing-level-feature.jsx
 ** module id = 784
 ** module chunks = 0
 **/